var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 321.7 321.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#428263}.st2{fill:#387053}.st3{fill:#398755}.st4{fill:#2b5e41}.st5{fill:#499161}.st7{fill:#214c35}.st12{fill:#aa9157}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.8 67.8c-2.6.6-22.6 181.8-22.6 181.8s.7-3.6 17.3 2.7c16.6 6.4 51.7 9.4 51.7 9.4s10-81.8 15-86.9l21.7 86.9s70-15.4 72.2-15.4l-36-176.5S165.8 81.7 157 81.7s-50.6-16.2-60.2-13.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8 67.8c-2.6.6-22.6 181.8-22.6 181.8s.7-3.6 17.3 2.7c6.8 2.6 16.6 4.6 25.8 6.1 1.9-29.8 2.4-49.8-5.7-88.9-5.5-26.7 3.2-64.4 10.9-97-11-3.1-21.5-5.7-25.7-4.7z",
    fill: "#386d51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M216.1 69.8s-14.9 3.5-29.8 6.7c3.6 18.5 12.1 52.9 26.7 59.5 8 3.6 13.7 4.7 17.7 4.7l-14.6-70.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.7 171.8c1.7 3.3 3.8 7.7 5.7 12.6 4.2 10.8 4.8 43.8 2.9 47.9-1.8 4.1-26.8 6.3-34.2 3.6-4.6-1.7-5.7-40-5.9-58.4-.1-5.4 4-6.8 9.5-7.3 14.5-1.2 19.5-3.3 22 1.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M224.5 230.3c-5-1.8-5.8-43.5-5.9-58.8 0 0-9.5-.1-9.4 4.5.2 17.7 1.3 58.3 6 60 7.4 2.7 32.4.5 34.2-3.6.2-.4.4-1.2.5-2.2-8.5 1.6-20.6 1.8-25.4.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M251.5 192.7c-.6-4.2-.4-6.9-1.2-9.5-3.9-13.1-14.6-17.3-14.6-17.3l-20 1.4c-3.8.3-6.7 3.5-6.6 7.3 0 5 .2 12.3.5 20.2l41.9-2.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1 246.4s-9.9-.7-9.9 3.2c0 4 53.3 13.6 69 12.1 0 .1-49.9-15.3-59.1-15.3z",
    fill: "#3e5b45"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M202 256.9c-7.6-18.6-16.1-41.5-20.8-57.6-3.5-11.9-18.7-48.1-22.9-24.5l21.7 86.9c0 .1 9.7-2.1 22-4.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.7 80.4s18.9 45.2 28.5 48.4h2.8l4.5 35.8-24.1 3.2-25.1-84.2 13.4-3.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M199.7 80.4c8.6 17.7 21.1 44.9 28.5 48.3l2.8.1c-.1 0-3 .1-2.9.1-9.8-3.7-24.8-38.6-28.4-48.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.8 67.8c-.9.2-4 23.1-7.6 52.5 9.7 2.7 20.2 4.3 22.3-.7 3-6.9 6.1-33.2 7.7-48-9.8-2.7-18.6-4.7-22.4-3.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113 80.4s-24.9 44-29.3 44l.4 38.8 27.6 8.3 12.7-88.1-11.4-3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.8 96.1c-7.6 12.6-17.5 28.3-20.2 28.3l.4 38.8 23.2 2.7c-2.2-20.5-3.1-46.8-3.4-69.8z",
    opacity: 0.43,
    fill: "#386d51"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M113 80.4c-6.1 12.3-24.7 43.8-29.3 44 3.1-.5 14.8-20.6 22.3-32.7.6-1.1-2.7 4.2 7-11.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84 163.2s-5.4 8.1-9.8 18.8c-4.5 10.7-1.7 43.8 0 48 1.7 4.2 22.4 7.2 29.8 4.5 4.5-1.7 6.9-44 7.7-60.9.2-3.9-2.7-7.3-6.6-7.8L84 163.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.5 165.6c-.7 16.7-3.1 59.6-7.7 61.3-4.8 1.7-15.3 1.1-22.4-.7.3 1.9.6 3.2.8 3.9 1.7 4.2 22.4 7.2 29.8 4.5 4.5-1.7 6.9-44 7.7-61 .2-3.9-2.7-7.2-6.5-7.7l-1.7-.3zm-8-106.8L94.9 77s53.7 11.8 70.2 8.8V71.4s-45.9-.7-69.6-12.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M153.2 80.4c0 5.5 4.8 9.7 10.3 8.9l55-7.7-1-20.3s-14.7 6.3-56.3 10.2c-4.6.4-8 4.4-8 8.9z",
    fill: "#3d7f59"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M153.2 92.7c1.9 28.6-.1 58.7 3.1 65.5 2.3 4.3 7.8 5.6 12.7 5.1-7.8 2.5-14.5-1.2-15.9-6.5-2.9-8.9-2.4-33.7-1.8-43.7.4-6.8 1-13.6 1.9-20.4z",
    fill: "#367252"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 162.1,
    cy: 79.6,
    r: 3.9
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.2 85.6l-6.8-1.3 4-20.2 6.7 1.4zm64.4 4.5l-4.7-22.5 6.8-1 4.7 22.1z",
    fill: "#366b4f"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.3 186.2c.7 3 1.2 7.6-.6 10.5-1.2 1.8-3.1 2.8-6 3.1l.4 4.6c4.4-.4 7.6-2.1 9.5-5.2 2.6-4.1 2.2-9.5 1.5-13h-4.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M74.3 192.7h8.2v2.3h-8.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235.8 189.9l5.7-1c.4 2.6 2.4 9.7 6.1 11.8.8.4 2.1.9 4.3.1l.3 5.9c-9.9 3.9-14.6-6.3-16.4-16.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M235 196.9h11.8v1.8H235z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M110.6 192.4c.4-7.5.8-15.4 1.1-20.5.1-2.9-2-5.9-4.9-6.3L84 162.8s-9.3 1.1-12.4 19.3c-.3 1.8-.5 4-.9 6.7l39.9 3.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.ce72917626361dda16d1b5a777105607.svg";
export { ForwardRef as ReactComponent };